// src/pages/HomePage.js - VERSION cohérente typo + boutons
import React from 'react';
import './HomePage.css';
import { useNavigate, Link } from 'react-router-dom';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="homepage">
      <div className="arabic-letters-bg">
        <div className="letter letter1"></div>
        <div className="letter letter2"></div>
        <div className="letter letter3"></div>
        <div className="letter letter4"></div>
        <div className="letter letter5"></div>
        <div className="letter letter6"></div>
        <div className="letter letter7"></div>
        <div className="letter letter8"></div>
        <div className="letter letter9"></div>
        <div className="letter letter10"></div>
        <div className="letter letter11"></div>
        <div className="letter letter12"></div>
        <div className="letter letter13"></div>
        <div className="letter letter14"></div>
        <div className="letter letter15"></div>
        <div className="letter letter16"></div>
        <div className="letter letter17"></div>
        <div className="letter letter18"></div>
        <div className="letter letter19"></div>
        <div className="letter letter31"></div>
        <div className="letter letter32"></div>
        <div className="letter letter33"></div>
        <div className="letter letter34"></div>
        <div className="letter letter35"></div>
        <div className="letter letter36"></div>
        <div className="letter letter37"></div>
        <div className="letter letter38"></div>
        <div className="letter letter39"></div>
        <div className="letter letter40"></div>
        <div className="letter letter41"></div>
        <div className="letter letter42"></div>
        <div className="letter letter20"></div>
        <div className="letter letter21"></div>
        <div className="letter letter22"></div>
        <div className="letter letter23"></div>
        <div className="letter letter24"></div>
        <div className="letter letter25"></div>
        <div className="letter letter26"></div>
        <div className="letter letter27"></div>
        <div className="letter letter28"></div>
        <div className="letter letter29"></div>
        <div className="letter letter30"></div>
      </div>

      <div className="homepage-content">
        <div className="homepage-eyebrow">✦ Plateforme d'apprentissage</div>
        <h1 className="homepage-title">First<span className="title-accent">Arabic</span></h1>
        <p className="homepage-subtitle">Cours d'arabe, amazigh et darija avec des professeurs qualifiés</p>

        <div className="homepage-buttons">
          <button className="btn-eleve" onClick={() => navigate('/login')}>
            🎓 Je suis élève
          </button>
          <button className="btn-prof" onClick={() => navigate('/professor-login')}>
            👨‍🏫 Je suis professeur
          </button>
        </div>
      </div>

      <footer className="homepage-footer">
        <div className="footer-links">
          <Link to="/contact">Contact</Link>
          <Link to="/cgu">CGU</Link>
          <Link to="/mentions-legales">Mentions légales</Link>
          <Link to="/confidentialite">Confidentialité</Link>
        </div>
        <p className="footer-copyright">© 2026 FirstArabic - Tous droits réservés</p>
      </footer>
    </div>
  );
};

export default HomePage;
